{
  "more": "Подробнее в руководстве",
  "archiveProvider": {
    "label": "Про способ доступа к архиву",
    "text": "Единого стандарта архива у камер нет. Hikvision и совместимые — «Hikvision ISAPI», Dahua и совместимые — «Dahua CGI»: они дают шкалу записанного, перемотку и выгрузку фрагмента. Для всего остального остаётся «RTSP-повтор»: он покажет запись за выбранный интервал, но где запись есть, сказать не умеет — шкала останется пустой. Порт HTTP тут не порт RTSP: у части камер Dahua это 6080."
  },
  "monitorThresholds": {
    "label": "Про пороги",
    "text": "Порог падения — сколько неудачных проверок подряд считать падением, порог возврата — сколько удачных считать возвратом. Единица означает «сообщать о каждой потере пакета», и на обычной сети это поток ложных тревог. Пороги применяет платформа, а не агент, поэтому менять их можно на ходу."
  },
  "mapLayers": {
    "label": "Про слои",
    "text": "Слои — это не отдельные карты: пространство у площадки одно, и связь между узлами разных слоёв обычная. Слой гасят, чтобы разглядеть, что под ним; погашенный уносит с собой и связи, уходящие с него. Что видно — предпочтение зрителя и хранится в браузере. Новые узлы и рамки ложатся на выбранный слой."
  }
}
